export const CLIENT_FORM_MODES = {
  ADD: 'ADD',
  EDIT: 'EDIT',
}



// WEBPACK FOOTER //
// ./src/Containers/Clients/const.js